import styled, { css } from 'styled-components';

import { formatBytes, getExtension } from '../../utils/FileControlUtil';
import NaverWorksIcon from './NaverWorksIcon';
import { noTextSelect } from '../common/CssCommon';
import {
  NAVERWORKS_DRIVE_TYPE,
  NAVERWORKS_SUPPORT_IMAGE_EXT,
  SUPPORT_IMAGE_THUMBNAIL_SIZE
} from '../../define/naverworksDefine';
import { convModifiedTime, getFileIcon, isFolder } from '../../utils/NaverWorksUtil';
import GridLayout from '../common/GridLayout';
import { useTranslation } from 'react-i18next';

const Main = styled.div`
  width: 100%;
  height: 100%;
  padding: 0px 22px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

const Description = styled.div`
  font-size: 12px;
  color: #aaadb0;
  margin-bottom: 8px;
`;

const GridItem = styled.div`
  width: 120px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  align-items: center;
  cursor: pointer;
`;

const ThumbnailArea = styled.div`
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1px;
  border: solid 1px #d4d9de;
`;

const IconImage = styled.img`
  width: 48px;
  height: 48px;
`;

const FileNameArea = styled.div`
  width: 100%;
  height: 36px;
  font-size: 12px;
  line-height: 1.33;
  text-align: center;
  color: #2f3133;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const GridCss = css`
  row-gap: 8px;
  column-gap: 20px;
`;

export default function ThumbnailView({ filteringList, onClickFolder, openDocument }) {
  const { i18n } = useTranslation();
  const checkSupportImageSize = (fileSize) =>
    fileSize <= SUPPORT_IMAGE_THUMBNAIL_SIZE * 1024 * 1024;

  return (
    <Main>
      <Description>
        {i18n.t('NaverWorksFileNavigator.SupportThumbnailSize', {
          Size: SUPPORT_IMAGE_THUMBNAIL_SIZE
        })}
      </Description>
      <GridLayout column={4} gap={0} cssExt={GridCss}>
        {filteringList &&
          filteringList.map((item) => (
            <GridItem
              key={item.fileId}
              onClick={() => {
                if (isFolder(item.fileType)) {
                  onClickFolder(NAVERWORKS_DRIVE_TYPE.PERSONAL, 'me', item.fileId, item.fileName);
                } else {
                  openDocument(NAVERWORKS_DRIVE_TYPE.PERSONAL, 'me', item.fileId);
                }
              }}>
              <ThumbnailArea>
                {Object.keys(NAVERWORKS_SUPPORT_IMAGE_EXT).includes(
                  getExtension(item.fileName).toLowerCase()
                ) && checkSupportImageSize(item.fileSize) ? (
                  <NaverWorksIcon
                    type={NAVERWORKS_DRIVE_TYPE.PERSONAL}
                    driveId={'me'}
                    fileId={item.fileId}
                    fileExt={getExtension(item.fileName).toLowerCase()}
                    defaultImage={getFileIcon(item.fileType, item.fileName, true)}
                  />
                ) : (
                  <IconImage src={getFileIcon(item.fileType, item.fileName, true)} />
                )}
              </ThumbnailArea>
              <FileNameArea title={item.fileName}>{item.fileName}</FileNameArea>
            </GridItem>
          ))}
      </GridLayout>
    </Main>
  );
}
